<template>
<div>
  <ul class="px-4 py-2 space-y-2" >
      <li v-for="page in pages" v-bind:key="page.id">
         <input
          v-model="selectedFilter"
          :value="page.id"
          class="appearance-none focus:ring-0 mr-3  focus:bg-blue-200 checked:border-blue-300 checked:bg-blue-200 rounded-md text-blue-400 border-gray-300 w-6 h-6"
          type="checkbox"
        />
        <label class="text-sm">{{name(page)}}</label>
      </li>
    </ul> 
    <footer class="bg-platinumMild px-4 py-3">
      <button
        @click="applyFilters"
        type="button"
        class="apply-button"
        dusk="apply-filters-button"
      >
        Apply Filters
      </button>
    </footer>
  </div>
</template>

<script>
export default {
name: 'StatusesFilter',

  props: {
    activeFilters: Object,
    pages:{
      type:Array,
      require:true
    },
  },

  data: () => ({
    selectedFilter:[]
  }),

  mounted: function() {
    this.filters = {...this.activeFilters};
  },

  methods: {
    applyFilters: function() {
      this.$emit('change', this.selectedFilter);
    },
    name(page) {
      return JSON.parse(page.metadata)['name']
    }
  },
}
</script>

<style lang="scss" scoped>
  .apply-button {
    @apply w-full text-yank bg-white border border-platinum transition duration-300 ease-in-out rounded py-2 px-3 font-semibold text-sm hover:border-platinum active:bg-yank active:text-white active:border-yank focus:bg-yank focus:text-white focus:border-yank focus:outline-none;

    &:hover {
      box-shadow: 0 2px 11px rgba(55,54,77,0.08);
    }
  }
</style>